import React, { useState, useEffect } from "react";
import "./zone.css";
import Pageloader from "../../components/loader";
import {Button, Input, Typography, Space, Card, Form, Menu, Switch, InputNumber, Tooltip} from "antd";
import {EditOutlined, InfoCircleOutlined, MoreOutlined} from "@ant-design/icons";
import { DevSDummyPermissionHelper, userhasPermissionHelper, validationErrors } from "../../utils/Helpers";
import * as zoneActions from "../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useNavigate } from "react-router-dom";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";
// import { async } from "q";
const { Text, Title } = Typography;
const { Search } = Input;

// const menu = (
//   <Menu
//     items={[
//       {
//         key: "1",
//         label: <a href="#">Edit</a>,
//       },
//     ]}
//   />
// );

const pagename = "Zone";
const pageLink = "zone";

const Zone = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    postLists();
  }, []);
  const postLists = async () => {
    try {
      setLoading(true);
      await props.zoneActions.getStoreListAction();
    } catch (e) {
      validationErrors(e);
    } finally {
      setLoading(false);
    }
  };

  const [search, setSearch] = useState("");
  const globalSearch = (postData) => {
    if (search.length == 0) {
      return postData;
    } else {
      return postData.filter((item) => {
        return JSON.stringify({name: item.zone.zoneName.toLowerCase() ,display_id: item.zone.display_id}).includes(search)
      });
    }
  };
  const onChangezonemeter = async (zId, ValLoc) => {
    const newVal = {"validate_location": ValLoc == true ? 0:1};
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }
  const onChangePicturePackTime = async (zId, ValLoc, location100M) => {
    const newVal = {
      "picture_pack_time": ValLoc == true ? 0:1,
      "validate_location": location100M == true ? 1:0,
    };
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }
  
  const onChangeShiftStartMart = async (zId, ValLoc, location100M) => {
    const newVal = {
      "shift_start_at_mart": ValLoc == true ? 0:1,
      "validate_location": location100M == true ? 1:0,
    };
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }

  const onChangeReachedMart = async (zId, ValLoc, location100M) => {
    const newVal = {
      "reached_mart": ValLoc == true ? 0:1,
      "validate_location": location100M == true ? 1:0,
    };
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }

  const onChangeStartStopCron = async (zId, ValLoc, location100M) => {
    const newVal = {
      "cron_status": ValLoc == true ? 0:1,
      "validate_location": location100M == true ? 1:0,
    };
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }
  const onChangeStorePacktimeLogic = async (zId, ValLoc, location100M) => {
    const newVal = {
      "has_ship_time": ValLoc == true ? 0:1,
      "validate_location": location100M == true ? 1:0,
    };
    try {
      await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
    } catch (e) {} finally {
      postLists();
    }
  }

  const onFinishFirstAssignmentDistance = async(zId, val, location100M) => {    
    var x=val
    if (x==null || x=="") {
      alert("field must be filled in numeric characters");
      return false;
    } else if (x = !/^[0-9_.]+$/.test(x)) {
      alert("field must have numeric characters");
      return false;
    } else {
      const newVal = {
        "first_assignment_distance": val,
        "validate_location": location100M == true ? 1:0,
      };
      try {
        await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
      } catch (e) {} finally {
        postLists();
      }
    }
  }

  const onFinishTimeSettingPackmate = async(zId, val, location100M) => {    
    var x=val
    if (x==null || x=="") {
      alert("field must be filled in numeric characters");
      return false;
    } else if (x = !/^[0-9_.]+$/.test(x)) {
      alert("field must have numeric characters");
      return false;
    } else {
      const newVal = {
        "time_setting_packmate": val,
        "validate_location": location100M == true ? 1:0,
      };
      try {
        await props.zoneActions.postZoneValidateLocationAction(zId, newVal);
      } catch (e) {} finally {
        postLists();
      }
    }
  }
  
  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}s Management</Title>
        </div>
        <div className="pch">
          <Space>
            <Search
              placeholder="Search Zone or ID"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onSearch={globalSearch}
            />
          </Space>
          {(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_ZONES) === true) &&
            <Button onClick={()=>navigate(`/${pageLink}/add`)}>{`Add Zone`}</Button>
          }
        </div>
      </div>
      {loading ? (
        <Pageloader />
      ) : (
        <div className="zone-page">
          {
            props.storeData && globalSearch(props.storeData).map((item, i) => {
              return (
                <Card bordered hoverable key={i}>
                  <div className="page-content-header">
                    <Title level={5}>{item.zone.zoneName}</Title>
                    {(userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_ZONES) === true) &&
                      <EditOutlined onClick={()=>navigate(`/zoneEdit/`+item.zone.id)} />
                    }
                    {/* <Dropdown overlay={menu}>
                      <Button>
                        <MoreOutlined />
                      </Button>
                    </Dropdown> */}
                  </div>
                  <hr />
                  <Space direction="vertical">
                    <Text><strong>Zone ID: </strong>{item.zone.display_id}</Text>
                    <Text><strong>Is Active: </strong>{item.zone?.isActive === true ? "Yes":"No"}</Text>
                    <Text><strong>Store ID: </strong>{item?.storeId}</Text>
                    <Title level={5}>Store</Title>
                    {item.stores && item.stores.map((sItem)=>{
                      return (
                        <>
                          <Text><strong>Name: </strong>{sItem.name}</Text>
                          <Text><strong>Address: </strong>{sItem.address}</Text>
                        </>
                      )
                    })}
                    <Text><strong>100M location validation: </strong>
                      <Switch defaultChecked={item && item.validate_location === true} onChange={()=>onChangezonemeter(item.storeId, item.validate_location)} />
                    </Text>
                    <Text><strong>Order packed time logic: </strong>
                      <Switch defaultChecked={item && item.has_ship_time === true} 
                      onChange={(e)=>onChangeStorePacktimeLogic(item.storeId, item.has_ship_time, item.validate_location)} />
                    </Text>
                    <Text><strong>Order Picture Packed Time: </strong>
                      <Switch defaultChecked={item && item.picture_pack_time === true} onChange={(e)=>onChangePicturePackTime(item.storeId, item.picture_pack_time, item.validate_location)} />
                    </Text>
                    <Text><strong>Shift Start Radius: </strong>
                      <Switch defaultChecked={item && item.shift_start_at_mart === true} onChange={(e)=>onChangeShiftStartMart(item.storeId, item.shift_start_at_mart, item.validate_location)} />
                    </Text>
                    <Text><strong>Reached Mart: </strong>
                      <Switch defaultChecked={item && item.reached_mart === true} onChange={(e)=>onChangeReachedMart(item.storeId, item.reached_mart, item.validate_location)} />
                    </Text>
                    {
                      (DevSDummyPermissionHelper(props?.emailUser?.email)) &&
                        <Text><strong>Cron start/stop: </strong>
                          <Switch defaultChecked={item && item.cron_status === true} onChange={(e)=>onChangeStartStopCron(item.storeId, item.cron_status, item.validate_location)} />
                        </Text>
                    }
                    <Search
                      style={{maxWidth: '100%'}}
                      defaultValue={item?.first_assignment_distance}
                      addonBefore={<>
                        FAD <Tooltip title="First Assignment Distance"><InfoCircleOutlined /></Tooltip>
                      </>}
                      suffix="KM"
                      enterButton="Submit"
                      onSearch={(val)=>onFinishFirstAssignmentDistance(item.storeId, val, item.validate_location)}
                    />
                    <Search
                      style={{maxWidth: '100%'}}
                      defaultValue={item?.time_setting_packmate}
                      addonBefore={<>
                        TSP <Tooltip title="Time Setting for Packmate"><InfoCircleOutlined /></Tooltip>
                      </>}
                      suffix="Hrs"
                      enterButton="Submit"
                      onSearch={(val)=>onFinishTimeSettingPackmate(item.storeId, val, item.validate_location)}
                    />
                  </Space>
                </Card>
              );
            })}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    storeData: state.ZoneReducer.storeData,
    emailUser: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Zone);
